var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loader',{attrs:{"title":"Connecting to the server","loading":!_vm.core.ready,"full":""}}),(_vm.core.ready && _vm.core.authenticated && _vm.$route.meta.layout === 'full')?_c('FullLayout'):(
      _vm.core.ready &&
      _vm.core.authenticated &&
      _vm.$route.name !== 'intro' &&
      _vm.$route.name !== 'quote'
    )?_c('MainLayout'):(_vm.core.ready)?_c('GuestLayout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }